import React from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../stores/AppStore'
import TemplateData, { localsMessages, isMobileHeaderExp } from '../../utility/getTemplateData'
import PostTransaction from '../confirmation/postTransaction'
import * as FPT from '../../utility/fpt'
import HurricaneHarveyCard from '../../components/HurricaneHarveyCard';
import SignUpAlert from '../../components/guest/SignUpAlert';
import { shouldShowHurricaneHarveyPromotion } from '../../utility/helper.js';
import _isFunction from 'lodash/isFunction';
import { hideLanguageSelector } from '../../utility/languageSelector';
import { hideSpinnerOverlay, setFocus } from '../../utility/helper';
import { sanitize } from '../../utility/domUtils';
import { Text } from '@paypalcorp/pp-react';
import ConfirmationCheckmark from '../../confirmation/ConfirmationCheckmark';
import ConfirmationMessage from '../../confirmation/ConfirmationMessage';
import ConfirmationReturnText from '../../confirmation/ConfirmationReturnText';
import ConfirmationReturnTo from '../../confirmation/ConfirmationReturnTo';
import OfferConfirmation from '../../components/offerConfirmation';
import VoucherFlowDisclaimer from '../../components/voucherFlowDisclaimer';
import templateData from '../../utility/getTemplateData'
import _get from 'lodash/get';

const messages = localsMessages('confirmation/confirmation')
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();

export default class extends React.Component {
    static propTypes = {
		label: PropTypes.string
	};

    constructor(props) {
        super(props);
        let confirmationData = AppStore.getConfirmation() || {}

        this.state = {
			amount: confirmationData.amount || '',
			confirmationNumber: confirmationData.confirmationNumber || '',
			postBackData: confirmationData || {},
			displayMyAccount: confirmationData.showAccountOverview || false,
			orgName : (TemplateData.donationName) ? TemplateData.donationName : '',
			txnId: confirmationData.postBackData && confirmationData.postBackData.txn_id || '',

			autoRedirect : TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl : (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : '',
			syncReturnUrl: confirmationData.syncReturnUrl || '',

			isSignUp: confirmationData.isSignUp || false,
			signUpStatus: confirmationData.signUpSuccess || false,
			isVoucherFlow: templateData.isVoucherFlow,
			offerProgram: templateData.offerProgram
		};
    }

    componentDidMount() {
		this.isComponentMounted = true;
		hideLanguageSelector();

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then((response) => {
			hideSpinnerOverlay();
			setFocus();
			if(response.data.confirmationData){
				if (this.isComponentMounted) { // Dont call setState on an unmounted component
					this.setState({
						amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
						guestSignUp: response.data.confirmationData.guestSignUp || false ,
						displayMyAccount: response.data.confirmationData.showAccountOverview || false,
						txnId: _get(response.data.confirmationData, 'postBackData.txn_id', '')
					})
				}
			}
		});

		let confData = AppStore.getConfirmation() || {}
		let isSignUp = confData.showAccountOverview || false;
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp' || isSignUp) {
			FPT.trackPage('main:donate:wps:signup:success', 'main:donate:wps:signup:success:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:success', 'main:donate:wps:guest:success:web::', 'trid', trid)
		}
	}

    componentWillUnmount() {
		this.isComponentMounted = false;
		if (this.serverRequest && _isFunction(this.serverRequest.abort)) {
			this.serverRequest.abort()
		}

	}

    handleMyAccount = () => {
		FPT.trackLinkClick('myAccount');
		window.location.href = '/myaccount'
	};

    handleAuthRedirectFail = () => {

		let finalUrl = this.state.autoRedirectUrl

		if (this.state.syncReturnUrl) {
			finalUrl = this.state.syncReturnUrl
		}

		if (finalUrl.indexOf('http') != 0 && finalUrl.indexOf('//') != 0) {
		    finalUrl = '//' + finalUrl;
		}

		window.location.href = finalUrl
	};

    renderHurricaneHarveyCard = () => {
		if (shouldShowHurricaneHarveyPromotion()) {
			return <HurricaneHarveyCard pageName="guest"/>
		}
		return null;
	};

    render() {
		const { label = {}} = messages || {}
		const { successMessage, failMessage } = label
		const signUpStatus = this.state.signUpStatus
		let yourdonation = label.yourdonation
		let voucherYourDonation = _get(label, 'voucher.yourdonation');
		let returnText = label.returnText
		let returnto = label.returnto
		let txnId = label.txnId

		if (this.state.isVoucherFlow) {
			yourdonation = voucherYourDonation
		}
		yourdonation = yourdonation && yourdonation.replace('{amount}', this.state.amount)
		yourdonation = yourdonation && yourdonation.replace('{orgName}', sanitize(this.state.orgName))

		returnText = returnText && returnText.replace('{orgName}', this.state.orgName)

		returnto = returnto && returnto.replace('{orgName}', this.state.orgName)

		txnId = txnId && txnId.replace('{txnId}', this.state.txnId)

		const guestSignUpProps = { signUpStatus, successMessage, failMessage }

		let rp_status =  AppStore.getDonationRecurring() === 'checked'
		let yourRPdonation = label.yourRPdonation
		yourRPdonation = yourRPdonation && yourRPdonation.replace('{amount}', this.state.amount)
		yourRPdonation = yourRPdonation && yourRPdonation.replace('{orgName}', sanitize(this.state.orgName))

		let giftaidFlag = AppStore.getGiftaidItFlagStatus();
		let donatedAmount = AppStore.getDonationAmount();
		let extraDonateAmount = giftaidFlag ? (TemplateData.donationSymbol + ((donatedAmount * donateGiftPercentage) - donatedAmount).toFixed(2)) : '';

		let giftAidConfText = giftaidFlag ? (rp_status ? label.giftAidRecurring : label.giftAid) : '';

		return (
			<div>
				{this.state.isSignUp && <SignUpAlert { ...guestSignUpProps } />}
				<div className={`donate_wrapper confirmation ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
					<div className="ppvx_row">
						<div className="ppvx_col-12">
							<ConfirmationCheckmark confirmationNumber={this.state.confirmationNumber}/>
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12">
							<ConfirmationMessage
								yourDonation={rp_status ? yourRPdonation : yourdonation}
								giftaidFlag={giftaidFlag}
								extraDonateAmount={extraDonateAmount}
								giftAid={giftAidConfText}
							/>
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12 text-center">
							<Text
								size="sm"
								style={{
									color: '#687173',
								}}
							>
								{txnId}
							</Text>
						</div>
					</div>
					{this.state.isVoucherFlow &&
						<OfferConfirmation
							offerProgram={this.state.offerProgram}
							txnId={txnId}/>
					}
					{this.state.autoRedirect && this.state.autoRedirectUrl &&
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								<ConfirmationReturnText returnText={returnText} />
								<ConfirmationReturnTo
									handleAuthRedirectFail={this.handleAuthRedirectFail}
									returnto={returnto}
								/>
							</div>
							<PostTransaction
								orgName={this.state.orgName}
								postdata={this.state.postBackData}
								syncReturnUrl={this.state.syncReturnUrl}
								method={this.state.autoRedirectMethod}
								action={this.state.autoRedirectUrl}/>
						</div>
					}
					{this.state.isVoucherFlow && <VoucherFlowDisclaimer />}
				</div>

				{this.renderHurricaneHarveyCard()}
			</div>
		);
	}
}
